<<!--  -->
<template>
  <el-row class="example">
    <el-row class="line-30">
      1.框架：elment-ui (2.12.0版本
      网址：
      <a
        class="c-8f7"
        href="https://element.eleme.cn/#/zh-CN"
        target="_blank"
      >https://element.eleme.cn/#/zh-CN</a>
    </el-row>
    <el-row class="line-30">
      <el-col>2.头部的导航条：xingluo_components(1.1.13版本)</el-col>
    </el-row>
    <el-row>
      <el-col>
        3. ui整体居中1200px,全局字12px;字体颜色为默认色号，特殊选中情况下为主题颜色
        <span class="c-8f7">#6435E8</span>;
      </el-col>
    </el-row>
    <el-row class="mt-20">
      <el-col>4.table表格</el-col>
    </el-row>
    <!-- table -->
    <el-table :data="list" ref="multipleTable">
      <el-table-column label="商品" width="300" inline>
        <template slot-scope="scope">
          <div class="flex">
            <img :src="scope.row.img" class="rest-table-img" />
            <div class="ml-10 justify">
              <div>{{scope.row.title}}</div>
              <div>商品id:{{scope.row.id}}</div>
              <div class="bold">店铺：【淘宝】{{scope.row.store_name}}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="价格" width inline>
        <template slot-scope="scope">
          <div>¥{{Number(scope.row.price)}}</div>
        </template>
      </el-table-column>
      <el-table-column label="日期" width inline>
        <template slot-scope="scope">
          <div>开始时间{{scope.row.date}}</div>
          <div>结束时间{{scope.row.date}}</div>
        </template>
      </el-table-column>
      <el-table-column label="合作方式" width inline>
        <template slot-scope="scope">
          <div>团长合作</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width inline>
        <template slot-scope="scope">
          <div>
            <el-button size="mini" @click="showTankuang(1)">查看详情</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-row>
      <el-col :span="24">
        <el-col :span="24" class="flex-sb flex-ac line-20 mt-20">
          <div>
            <span>第</span>
            <span class="fz-13">{{page}}</span>
            <span>页</span>
          </div>
          <div>
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="getData"
                :current-page.sync="page"
                :page-size="offset"
                :page-sizes="[20,40,80,100]"
                layout="total,sizes,prev, pager, next, jumper"
                :total="count"
              ></el-pagination>
            </div>
          </div>
        </el-col>5.分页
        <div>(1)分页距离上面table设置margin-top：20px;</div>
        <div>(2)支持切换每页条数</div>
        <div>(3)导出的时候将每页条数置空，全部导出</div>
      </el-col>
    </el-row>
    <el-row class="mt-20">
      <el-col :span="24">6.弹框</el-col>
      <el-col class="mt-20">
        <el-button type="primary" @click="showTankuang(2)">dialog</el-button>
      </el-col>
    </el-row>
    <el-row class="mt-20">
      <el-col :span="24">7.表单</el-col>
    </el-row>
    <el-row>
      <el-form class label-position="right" ref="form" label-width="140px" :model="form" inline>
        <el-form-item label="数字输入框" clearable>
          <el-input
            v-model="form.price"
            class="w-230"
            type="number"
            @mousewheel.native.prevent
            placeholder="这是数字输入框"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="兼容safari的日期">
          <el-date-picker
            class="w-230"
            v-model="form.date"
            type="date"
            placeholder="选择日期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="波段选择">
          <el-date-picker
            class="w-230"
            v-model="form.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getChanges"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <el-form class label-position="right" ref="form" label-width="140px" :model="form" inline>
        <el-button type="primary">搜素</el-button>
        <el-button>重置</el-button>
      </el-form>
    </el-row>
    <el-row class="mt-20">
      <el-col :span="24">8.全局公共的css文件</el-col>
      <el-col>plugins下面的rest.css文件可以设置全局的类名</el-col>
    </el-row>
    <el-row class="mt-20">
      <el-col :span="24">9.上传组件</el-col>
      <el-col class="mt-20">
        <Upsome :file_list="file_list" :type="1" :limits="limits" @getPic="getPic"></Upsome>
      </el-col>
    </el-row>
    <el-row class="mt-20">
      <el-col :span="24">10.选项卡</el-col>
      <el-col class="mt-20">
        <el-tabs v-model="active" type="card" @tab-click="handleClick">
          <el-tab-pane :name="item.status" v-for="(item,index) in tag_list" :key="index">
            <span slot="label">{{item.name}}({{item.num}})</span>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-dialog
      :title="title"
      width="520px"
      :visible.sync="dialog"
      :before-close="hideTankuang"
      :close-on-click-modal="false"
    >
      <div></div>
      <span slot="footer">
        <el-button @click="hideTankuang">取消</el-button>
        <el-button type="primary" @click="hideTankuang">确认</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>


<script>
import Upsome from "../template/upsome";
import util from "../../utils/util";
export default {
  name: "example",
  data() {
    return {
      page: 1,
      count: 9999,
      offset: 10,
      dialog: false,
      form: {
        price: "",
        date: "",
        time: "",
        start: "",
        end: ""
      },
      file_list: [],
      limits: 4,
      some_img: "",
      active: '1',
      list: [
        {
          img:
            "https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=4152481805,113797299&fm=26&gp=0.jpg",
          title: "粉饼控油定妆遮瑕持久补妆干粉女散粉 正品抖音热卖",
          id: "563898557860",
          store_name: "多彩丽人商城",
          price: "12.12",
          date: "2020-03-05 12:12:11"
        },
        {
          img:
            "https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=4152481805,113797299&fm=26&gp=0.jpg",
          title: "粉饼控油定妆遮瑕持久补妆干粉女散粉 正品抖音热卖",
          id: "563898557860",
          store_name: "多彩丽人商城",
          price: "12.12",
          date: "2020-03-05 12:12:11"
        }
      ],
      tag_list: [
        {
          name: "待提交订单",
          num: 0,
          status: "7"
        },
        {
          name: "待审核订单",
          num: 0,
          status: "3"
        },
        {
          name: "待支付订单",
          num: 0,
          status: "1"
        },
        {
          name: "支付成功订单",
          num: 0,
          status: "2"
        },
        {
          name: "全部订单",
          num: 0,
          status: "-1"
        }
      ],
      title: ""
    };
  },
  components: {
    Upsome: Upsome
  },
  created() {},
  mounted() {
    this.setToday();
  },
  methods: {
    showTankuang(num) {
      if (num == 1) {
        this.title = "查看详情";
      } else if (num == 2) {
        this.title = "这是弹框";
      }
      this.dialog = true;
    },
    hideTankuang() {
      this.dialog = false;
    },
    handleSizeChange(e) {
      //切换每页条数
      //重新刷新列表
      this.sazi = e;
    },
    getData(e) {
      //去到某一页
      //重新刷新列表
      this.page = e;
    },
    setToday() {
      let date = "2020-02-02";
      this.form.date = date.replace(/-/g, "/");
    },
    getPic(data) {
      //获取子组件传回的图片
      this.some_img = data;
    },
    getChanges(e) {
      if (this.form.time) {
        this.form.start = util.dateFormat(new Date(this.form.time[0])).full;
        this.form.end = util.dateFormat(new Date(this.form.time[1])).full;
      }
    },
    handleClick() {}
  }
};
</script>
<style  scoped>
.pl-20 {
  padding-left: 20px;
}
.line-20 {
  line-height: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.line-30 {
  line-height: 30px;
}
.ml-10 {
  margin-left: 10px;
}
.example {
  width: 1200px;
  margin: 0 auto;
  font-size: 12px;
  padding-bottom: 100px;
}
.w-200 {
  width: 200px;
}
.w-230 {
  width: 230px;
}
</style>